import { TTransshipmentStepId } from '../../types';

export const representativeFinalizePersonalData = {
  path: 'dados-pessoais',
  next: () => 'identity-document-type-page' as TTransshipmentStepId,
};

export const spouseFinalizePersonalData = {
  path: 'avalista/conjuge',
  next: (): TTransshipmentStepId => 'identity-document-type-page',
};
